
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Home as HomeIcon, Wrench, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';
import NavigationHeader from "../components/NavigationHeader";

const Maintenance = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* شريط التنقل */}
      <NavigationHeader />

      {/* محتوى الصفحة */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center">
          <div className="mx-auto w-32 h-32 bg-orange-100 rounded-full flex items-center justify-center mb-8">
            <Wrench className="h-16 w-16 text-orange-600" />
          </div>
          
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            خدمات الصيانة
          </h1>
          
          <p className="text-xl text-gray-600 mb-8">
            قريباً سيتم توفيرها
          </p>
        </div>

        <Card className="max-w-2xl mx-auto">
          <CardHeader className="text-center">
            <CardTitle className="flex items-center justify-center">
              <Clock className="h-6 w-6 ml-2 text-blue-600" />
              قريباً سيتم إضافة هذه الخدمة
            </CardTitle>
            <CardDescription>
              نحن نعمل بجد لتقديم خدمات صيانة شاملة لجميع أنواع العقارات
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="bg-blue-50 p-4 rounded-lg">
                <h3 className="font-semibold text-blue-900 mb-2">صيانة عامة</h3>
                <p className="text-blue-700 text-sm">
                  خدمات الصيانة العامة للمنازل والشقق
                </p>
              </div>
              
              <div className="bg-green-50 p-4 rounded-lg">
                <h3 className="font-semibold text-green-900 mb-2">صيانة طارئة</h3>
                <p className="text-green-700 text-sm">
                  خدمات الطوارئ على مدار 24 ساعة
                </p>
              </div>
              
              <div className="bg-purple-50 p-4 rounded-lg">
                <h3 className="font-semibold text-purple-900 mb-2">صيانة دورية</h3>
                <p className="text-purple-700 text-sm">
                  جدولة صيانة دورية لعقارك
                </p>
              </div>
              
              <div className="bg-orange-50 p-4 rounded-lg">
                <h3 className="font-semibold text-orange-900 mb-2">تقييم العقارات</h3>
                <p className="text-orange-700 text-sm">
                  فحص وتقييم حالة العقارات
                </p>
              </div>
            </div>


         
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Maintenance;
